export default "__VITE_ASSET__sml8escP__"